import React from 'react';
import { PageLayout } from 'src/core/components';

import MCPLayout from '../components/MCPLayout';
import messages from './messages';

export const MCPPageComponent = () => (
  <PageLayout title={messages.mcpPageTitle}>
    <MCPLayout />
  </PageLayout>
);

MCPPageComponent.propTypes = {};

export default MCPPageComponent;
